module.exports = __webpack_public_path__ + "static/media/dinner1.b156cd26.jpg";